export default {
  title: "Usuarios"
  , button: { perfiles: "Perfiles" }
  , form: {
    username: {
      label: "Usuario"
      , th: "Usuarios"
    }
    , nombre: {
      label: "Nombre"
      , th: "Nombre (Usuario)"
    }
    , telefono: { label: "Teléfono" }
    , interno: { label: "Interno" }
    , celular: { label: "Celular" }
    , correoElectronico: { label: "Correo Electrónico" }
    , foto: { label: "Previsualización de foto" }
    , enabled: { label: "Estatus" }
    , activo: { label: "¿Permite reset password?" }
    , idVendor: { label: "Vendor" }
    , idRep: { label: "REP" }
    , tipoUsuario: {
      label: "Tipo de Usuario"
      , administrador: { label: "Administrador" }
      , vendor: { label: "Vendor" }
      , rep: { label: "REP" }
    }
  }
  , errors: {
    BD2001: { text: "Ocurrió un error en el catálogo de Usuarios" }
    , WS2001: { text: "Ocurrió un error en el catálogo de Usuarios" }
    , JS2001: { text: "Ocurrió un error en el catálogo de Usuarios" }
    , CR2001: { text: "Ocurrió un error en el catálogo de Usuarios" }
    , PK2001: { text: "Ya existe un registro con el mismo usuario" }
    , SC0013: { text: "Su usuario está bloqueado, consulte al administrador" }
    , SC0004: { text: "Usuario no asignado a un grupo, contacte al administrador" }
    , UK_Users: { text: "Ya existe un registro con el mismo usuario" }
  }
  , rules: {
    idVendor: "Debe seleccionar un Vendor"
    , idRep: "Debe seleccionar un REP"
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/seguridad/usuario.js